export const CART_REWARD_ATTRIBUTE_NAME = '_reward'
export const CUSTOMER_REWARD_METAFIELD_NAMESPACE = 'custom'
export const CUSTOMER_REWARD_METAFIELD_KEY = 'rewards_1'
export const REWARD_POINTS_PER_POUND = 100
